<template>
	<SharedButton
		variant="secondary"
		append-icon="social-apple"
		:icon-prefix="false"
		aria-label="Apple Anmeldung"
		@click="startAppleLogin"
	/>
</template>

<script setup lang="ts">
import { store } from "@/state/store";
import { pushEvent } from "@/services/dataLayerLogin";
import SharedButton from "@SharedVueComponents/SharedButton.vue";

function startAppleLogin() {
	window.location.href = `${store.oAuthSignIn}?kc_idp_hint=apple`;
	pushEvent("AppleButton");
}
</script>
